export const MILES_NEARYBY_COURTS = 25;
export const MILES_NEARYBY_LESSONS = 25;
export const NEARBY_COURT_LIMIT = 200;
